<template>
  <div class="conversion-form">
    <div class="conversion-form-item">
      <component 
        ref="component"
        :is="componentName"
        @formchange="handleFormchange"
        :formData="formData"
        @updateForm="handleUpdateForm"
        :dTarget="target"
        :validNumber="handleValidNumber"
        :conversionPriceData="getConversionPriceData"
        :addType="addType"
        :avgData.sync="avgData"
      />
    </div>
    <div class="opt">
     
      <i class="el-icon-document-copy" @click="handleCopyClick"></i>
      <i class="el-icon-delete" @click="handleDelClick"></i>
      <!-- <span >{{index}}</span> -->
    </div>
  </div>
</template>

<script>
import conversionFormConv from './conversionFormConv.vue'
import API from '@/api/marketManage/miBatchAuto'
import { numStrip } from '@/utils'
export default {
  components: { },
  props: ['formData', 'addType', 'index'],
  inject:['getFormParams', 'appList'],
  data() {
    return {
      target: this.formData.target,
      form: { },
      avgData: null,//均值
    }
  },
  computed:{
    componentName() {
      return conversionFormConv;
    },
  },
  methods: {
    handleValidNumber(num) {
      const value = num+'';
      if (value.indexOf('.')>-1) {
         const list = value.split('.');
         if (list[1].length>2) {
          return [list[0], list[1].slice(0,2)].join('.')
         }
      }
    },
    handleDelClick() {
      this.$emit('updateFormNum', this.formData.id)
    },
    handleFormchange(value) {
      this.avgData = null;
      this.target = value;
      this.$nextTick(()=>{
        this.$refs.component.triggerPriceTip()
      })
    },
    // copy
    handleCopyClick() {
      this.$emit('copyFormData', { 
        ...this.form,
      })
    },
    // 更新
    handleUpdateForm(data) {
      // 等待target赋值后再取
      this.$nextTick(()=>{
        this.form = {
          ...data,
          id: this.formData.id
        };
      })
    },
    updateData() {
      const data = Object.keys(this.form).reduce((pre,v)=> {
        pre[v] = ""+this.form[v];
        return pre;
      }, {});
      const nameData = this.$refs.component.nameData;
      const deepNameData = this.$refs.component.deepNameData;
      const d = { ...data };
      if (nameData) {
        d.nameData = nameData;
      }
       if (deepNameData) {
        d.deepNameData = deepNameData;
      }
      return d;
    },
    // 获取均价
    async getConversionPriceData(p, cb) {
      try {
        const { display_type, app_id } = this.getFormParams();
        let ids = [ app_id ];
        if (this.addType === 1) {
          ids = this.appList.map(v=> v.app_id)
        };
        const params = {
          display_type,app_id: ids,
          ...p
        };
        // type tracking_type conversion_type
        if (!this.avgData) {
          const { data: d } = await API.getConversionPriceDataList(params);
          this.avgData = d
        }
        const n = this.avgData[`${p.type}_avg`]
        const data =  n? numStrip(p.value - n) +'' : n
        if (!data) {
           cb('--')
          return
        }
        const num = +data;
        if (num>0) {
          cb(`高${num}`)
        }else if(num === 0) {
           cb(`${num}`)
        }else {
          cb(`低${-num}`)
        }
      } catch (error) {
        cb('--')
        this.$message.error(error.info || '系统错误')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.conversion-form {
  display: flex;
  min-height: 170px;
  margin-bottom: 16px;
  &-item {
    flex: 1;
    width: 0;
    height: 100%;
    border: 1px solid #ccc;
    border-radius: 5px;
    box-sizing: border-box;
    padding: 12px 0;
  }
  .opt {
    width: 60px;
    text-align: right;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-right: 16px;
    i {
      display: block;
      margin-left: auto;
      font-size: 18px;
      margin-top: 20px;
      color: red;
      cursor: pointer;
      &:first-child {
        margin-top: 0;
        color: #409EFF;
      }
    }
  }
  &::v-deep .el-input-group__append {
    background: #409EFF;
    color: #fff;
  }
}
</style>